import styled from 'styled-components';

export const StepHeading = styled.h2`
	margin: 0;
	color: ${({ theme }) => theme.v2.color.neutral[1100]};
	font-variant-numeric: lining-nums tabular-nums;
	font-family: Inter, sans-serif;
	font-size: 1.125rem;
	font-style: normal;
	font-weight: 600;
	line-height: 1.5rem;
`;

export const StepSubHeading = styled.p`
	margin: 0;
	color: ${({ theme }) => theme.v2.color.neutral[700]};
	font-variant-numeric: lining-nums tabular-nums;
	font-family: Inter, sans-serif;
	font-size: 0.875rem;
	font-style: normal;
	font-weight: 400;
	line-height: 1.25rem;
`;
